import React, { useContext } from 'react';
import { LocalizationContext } from '../localization/LocalizationContext';
import { smartTranslateIngredients } from '../localization/foodTranslations';
import { parseMultiLanguageDescription } from '../utils/multiLanguageParser';
import '../css/productDetail.css'

const ProductDetailModal = ({ product, onClose }) => {
    const { translations, locale } = useContext(LocalizationContext);
    const pd = translations?.productDetail || {};
    const size = product.itemSizes?.[0] || {};
    const price = size.prices?.[0]?.price || 0;
    const imageUrl = size.buttonImageUrl;
    const allergens = product.allergens || [];
    
    const getTranslated = (id, field, fallback) => {
        // TESTING MODE - NO FALLBACKS
        if ((field === 'description' || field === 'name') && fallback) {
            // Try to parse multi-language format from Syrve
            const parsedText = parseMultiLanguageDescription(fallback, locale);
            return parsedText || fallback; // Show original if no translation
        }
        
        // For other fields, return original
        return fallback;
    };
    
    const getAllergenIcon = (allergen) => {
        if (!allergen || typeof allergen !== 'string') return '⚠️';
        const allergenLower = allergen.toLowerCase();
        if (allergenLower.includes('gluten') || allergenLower.includes('глютен') || allergenLower.includes('გლუტენი')) return '🌾';
        if (allergenLower.includes('milk') || allergenLower.includes('dairy') || allergenLower.includes('молоко') || allergenLower.includes('молочн') || allergenLower.includes('რძე')) return '🥛';
        if (allergenLower.includes('egg') || allergenLower.includes('яйц') || allergenLower.includes('კვერცხ')) return '🥚';
        if (allergenLower.includes('nut') || allergenLower.includes('walnut') || allergenLower.includes('орех') || allergenLower.includes('თხილ') || allergenLower.includes('კაკ')) return '🥜';
        if (allergenLower.includes('fish') || allergenLower.includes('рыб') || allergenLower.includes('თევზ')) return '🐟';
        if (allergenLower.includes('shellfish') || allergenLower.includes('crustacean') || allergenLower.includes('моллюск') || allergenLower.includes('ракообразн') || allergenLower.includes('კიბოს')) return '🦐';
        if (allergenLower.includes('soy') || allergenLower.includes('соя') || allergenLower.includes('სოი')) return '🌱';
        if (allergenLower.includes('sesame') || allergenLower.includes('кунжут') || allergenLower.includes('სეზამ')) return '🌰';
        return '⚠️';
    };

    return (
        <div className="product-detail-modal-overlay" onClick={onClose}>
            <div className="product-detail-modal" onClick={(e) => e.stopPropagation()}>
                <button className="close-modal-button" onClick={onClose}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M18 6l-12 12"/>
                        <path d="M6 6l12 12"/>
                    </svg>
                </button>

                <div className="product-detail-image-container">
                    {imageUrl ? (
                        <img src={imageUrl} alt={getTranslated(product.itemId, 'name', product.name)} className="product-detail-image"/>
                    ) : (
                        <div className="product-detail-no-image">{pd.noImageAvailable || 'No image available'}</div>
                    )}
                </div>

                <div className="product-detail-info">
                    <h2 className="product-detail-title">{getTranslated(product.itemId, 'name', product.name)}</h2>
                    <p className="product-detail-description">{getTranslated(product.itemId, 'description', product.description || pd.noDescriptionAvailable || 'No description available')}</p>
                    
                    {allergens && allergens.length > 0 && (
                        <div className="product-detail-allergens">
                            <div className="allergens-title">
                                {translations?.productDetail?.allergens || 'Allergens'}:
                            </div>
                            <div className="allergens-list">
                                {allergens.map((allergen, index) => {
                                    // Handle both string and object allergen formats
                                    const allergenRaw = typeof allergen === 'string' 
                                        ? allergen 
                                        : (allergen?.name || allergen?.code || '');
                                    
                                    if (!allergenRaw) return null;
                                    
                                    // Parse multi-language format for allergen text
                                    const allergenText = parseMultiLanguageDescription(allergenRaw, locale) || allergenRaw;
                                    
                                    return (
                                        <span key={allergen?.id || index} className="allergen-badge">
                                            <span className="allergen-icon">{getAllergenIcon(allergenText)}</span>
                                            <span className="allergen-text">{allergenText}</span>
                                        </span>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    
                    <div className="product-detail-price">{price} ₾</div>
                </div>
            </div>
        </div>
    );
};

export default ProductDetailModal;
